<template>
  <div class="guide-controls" v-if="product.toolimages.overlay">
    <b-button @click="toggleGuide" size="sm">
      <span v-if="guideVisible" :key="'off'">
        <b-icon-x-circle aria-hidden="true"></b-icon-x-circle>
        Turn off guide
      </span>
      <span v-else :key="'on'">
        <b-icon-plus-circle aria-hidden="true"></b-icon-plus-circle>
        Turn on guide
      </span>
    </b-button>
    <p><a href="/info/aboutlabels">more on label positions and cutting</a></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { BIconPlusCircle, BIconXCircle } from 'bootstrap-vue';

export default {
  name: 'GuideControls',
  components: {
    BIconPlusCircle,
    BIconXCircle,
  },
  props: {
    // msg: String,
  },
  data() {
    return {
    };
  },
  computed: mapState(['product', 'guideVisible']),
  methods: {
    toggleGuide() {
      console.log('toggleGuide to', !this.guideVisible);
      this.$store.commit('toggleGuide');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.guide-controls {
  font-size: 75%;
}

.guide-controls a {
  text-decoration: underline;
}

.btn-sm {
  padding: .25rem .5rem;
  font-size: .75rem;
  line-height: 1.0;
  border-radius: .2rem;
}
</style>
